module.exports = "/packs/images/pages/lee_valley/lvp_core_logo_lrg~4603a0105561a980e3e3afe9ddfb9911.png";